<script lang="ts">
    import { mdiPencil } from "@mdi/js"
    import Icon from "../../../widgets/Icon.svelte"
    import { checkPassword, onChange, removeAllErrors, validateEmail, validateField } from "../helper"
    import Input from "../../blocks/form/Input.svelte"
    import CardWrapper from "../CardWrapper.svelte"
    import { login, newNotification } from "../../../../store"
    import { changeEmail, changePassword } from "../../../../functions/CommerceAPIs/bigCommerce/customer"
    export let customer: BigCommerceCustomer
    const passwordChangeDetails = {
        currentPassword: "",
        password1: "",
        password2: "",
    }
    const emailChangeDetails = {
        email: "",
        currentPassword: "",
    }
    function changePasswordValidator() {
        const validations = [
            { id: "password1", value: passwordChangeDetails.password1, validator: checkPassword },
            { id: "password2", value: passwordChangeDetails.password2, validator: checkPassword },
        ]
        let isValid = true

        for (const { id, value, validator } of validations) {
            // @ts-ignore
            if (!validateField(id, value, validator)) isValid = false
        }
        if (passwordChangeDetails.password1 !== passwordChangeDetails.password2) {
            isValid = false
            newNotification({ html: "Passwörter stimmen nicht überein", class: "error" })
        }
        return isValid
    }

    function changeEmailValidator() {
        const validations = [{ id: "eMail", value: emailChangeDetails.email, validator: validateEmail }]
        let isValid = true

        for (const { id, value, validator } of validations) {
            // @ts-ignore
            if (!validateField(id, value, validator)) isValid = false
        }
        return isValid
    }
    let form: HTMLFormElement
    let editMode: "" | "password" | "email" = ""
</script>

<div class="wrapper">
    <CardWrapper>
        <form bind:this="{form}">
            <h3>Identifizierende Daten</h3>
            {#if editMode}
                {#if editMode === "password"}
                    <div class="row">
                        <Input
                            onChange="{onChange}"
                            bind:value="{passwordChangeDetails.currentPassword}"
                            placeholder="Aktuelles Passwort"
                            id="currentPassword"
                            type="password"
                        />
                    </div>
                    <div class="row">
                        <Input
                            onChange="{onChange}"
                            bind:value="{passwordChangeDetails.password1}"
                            placeholder="Neues Passwort"
                            id="password1"
                            type="password"
                        />
                        <Input
                            onChange="{onChange}"
                            bind:value="{passwordChangeDetails.password2}"
                            placeholder="Neues Passwort wiederholen"
                            id="password2"
                            type="password"
                        />
                    </div>
                {:else if editMode === "email"}
                    <div class="row">
                        <Input
                            onChange="{onChange}"
                            bind:value="{emailChangeDetails.currentPassword}"
                            placeholder="Aktuelles Passwort"
                            id="currentPassword"
                            type="password"
                        />
                    </div>
                    <div class="row">
                        <Input
                            onChange="{onChange}"
                            bind:value="{emailChangeDetails.email}"
                            placeholder="Neue E-Mail"
                            id="eMail"
                            type="text"
                        />
                    </div>
                {/if}
            {:else}
                <div class="row">
                    <div class="details">
                        <Input
                            onChange="{() => {}}"
                            bind:value="{customer.email}"
                            placeholder="E-Mail"
                            id="eMail"
                            disabled="{true}"
                            type="{editMode ? 'text' : 'noInput'}"
                        />
                        <Input
                            placeholder="Passwort"
                            id="password"
                            onChange="{onChange}"
                            type="noInput"
                            value=""
                        />
                    </div>
                </div>
            {/if}
            {#if editMode}
                <div class="action-button-line">
                    <button
                        class="cta primary"
                        on:click|stopPropagation|preventDefault="{() => {
                            editMode = ''
                            removeAllErrors(form)
                        }}">Änderungen verwerfen</button
                    >
                    <button
                        class="cta secondary"
                        on:click|stopPropagation|preventDefault="{() => {
                            if (editMode === 'password') {
                                if (changePasswordValidator()) {
                                    const res = changePassword(
                                        $login.tokenData.tibiId,
                                        passwordChangeDetails.currentPassword,
                                        passwordChangeDetails.password1
                                    )
                                    if (res) {
                                        editMode = ''
                                        passwordChangeDetails.currentPassword = ''
                                        passwordChangeDetails.password1 = ''
                                        passwordChangeDetails.password2 = ''
                                    }
                                }
                            } else {
                                if (changeEmailValidator()) {
                                    const res = changeEmail(
                                        $login.tokenData.tibiId,
                                        emailChangeDetails.email,
                                        emailChangeDetails.currentPassword
                                    )
                                    if (res) {
                                        editMode = ''
                                        customer.email = emailChangeDetails.email
                                        emailChangeDetails.email = ''
                                        emailChangeDetails.currentPassword = ''
                                    }
                                }
                            }
                        }}">Änderungen speichern</button
                    >
                </div>
            {:else}
                <div class="action-line">
                    <button
                        on:click|stopPropagation|preventDefault="{() => {
                            editMode = 'email'
                        }}"
                    >
                        <p>Email Ändern</p>

                        <span><Icon path="{mdiPencil}" /> </span></button
                    >

                    <button
                        on:click|stopPropagation|preventDefault="{() => {
                            editMode = 'password'
                        }}"
                    >
                        <p>Passwort Ändern</p>

                        <span><Icon path="{mdiPencil}" /> </span></button
                    >
                </div>
            {/if}
        </form>
    </CardWrapper>
</div>

<style lang="less">
    .wrapper {
        display: flex;
        width: 100%;
        flex-grow: 1;
        form {
            h3 {
                padding: 0px 2.4rem;
                color: var(--text-invers-100);
            }
            display: flex;
            flex-direction: column;
            gap: 24px;
            .row {
                padding: 0px 2.4rem;
                display: flex;
                gap: 24px;
                .details {
                    display: flex;
                    flex-direction: column;
                    gap: 1.2rem;
                }
            }
            .action-button-line,
            .action-line {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                button {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    gap: 10px;
                    width: 0px;
                    flex-grow: 1;
                }
            }
            .action-line {
                background: var(--bg-100);
                padding: 0.6rem 3.3rem 0.6rem 3.3rem;
                display: flex;
                flex-direction: row;
                align-items: center;
                height: 48px;
                justify-content: space-between;
                p,
                span {
                    color: var(--neutral-white);
                }
            }

            .action-button-line {
                height: 48px;
                display: flex;
                width: 100%;
                button {
                    width: 0px;
                    height: 100%;
                    flex-grow: 1;
                }
            }
        }
    }
</style>
